export default {
    ar: () => import('./ar.json'),
    'cs-CZ': () => import('./cs-CZ.json'),
    'da-DK': () => import('./da-DK.json'),
    'de-DE': () => import('./de-DE.json'),
    'el-GR': () => import('./el-GR.json'),
    'en-US': () => import('./en-US.json'),
    'es-ES': () => import('./es-ES.json'),
    'fi-FI': () => import('./fi-FI.json'),
    'fr-FR': () => import('./fr-FR.json'),
    'hr-HR': () => import('./hr-HR.json'),
    'hu-HU': () => import('./hu-HU.json'),
    'it-IT': () => import('./it-IT.json'),
    'ja-JP': () => import('./ja-JP.json'),
    'ko-KR': () => import('./ko-KR.json'),
    'nl-NL': () => import('./nl-NL.json'),
    'no-NO': () => import('./no-NO.json'),
    'pl-PL': () => import('./pl-PL.json'),
    'pt-BR': () => import('./pt-BR.json'),
    'ro-RO': () => import('./ro-RO.json'),
    'ru-RU': () => import('./ru-RU.json'),
    'sk-SK': () => import('./sk-SK.json'),
    'sl-SI': () => import('./sl-SI.json'),
    'sv-SE': () => import('./sv-SE.json'),
    'zh-CN': () => import('./zh-CN.json'),
    'zh-TW': () => import('./zh-TW.json')
};
